export default __webpack_public_path__ + "static/media/MVLP.892b1d34.png";